export default __webpack_public_path__ + "static/media/gmx-logo-final.5acbf23e.png";